import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';

import { ButtonComponent, FormDropdownComponent, ModalLayoutComponent, UI_FORM_IMPORTS } from '@program-suite/ui';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomDatePickerComponent } from "../../../../../../shared/ui-common/src/lib/components/form/custom-date-picker/custom-date-picker.component";
import { LookupStore } from '@program-suite/data-common';

@Component({
  selector: 'lib-prior-work-exclusion-modal',
  imports: [
    ModalLayoutComponent,
    ButtonComponent,
    FormDropdownComponent,
    ReactiveFormsModule,
    CustomDatePickerComponent,
    ...UI_FORM_IMPORTS
],
  templateUrl: './prior-work-exclusion-modal.component.html',
  styleUrl: './prior-work-exclusion-modal.component.scss',
})
export class PriorWorkExclusionModalComponent implements OnInit, AfterViewInit {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<PriorWorkExclusionModalComponent>);
  lookupStore = inject(LookupStore);

  submissionGuid = input.required<string | null>();
  requestType =input.required<string | null>();
  form!: FormGroup;

  constructor(private fb: FormBuilder) {
    // Load states lookup for the dropdown
    this.lookupStore.loadLookup('states');

    const baseFormControls: any = {
      removePriorWork: this.fb.control<boolean>(false),
      priorWorksEffectiveDate: this.fb.control(null),
      issuedEffectiveDate: this.fb.control(new Date(), Validators.required),
    };

    // Add agency/producer info fields if RetailAgentId is not set
    if (!this.data.retailAgentId) {
      baseFormControls.agencyName = this.fb.control(this.data.agencyName || '', Validators.required);
      baseFormControls.producerName = this.fb.control(this.data.producerName || '', Validators.required);
      baseFormControls.agencyAddress1 = this.fb.control(this.data.agencyAddress1 || '', Validators.required);
      baseFormControls.agencyAddress2 = this.fb.control(this.data.agencyAddress2 || '');
      baseFormControls.agencyCity = this.fb.control(this.data.agencyCity || '', Validators.required);
      baseFormControls.agencyStateCode = this.fb.control(this.data.agencyStateCode || null, Validators.required);
      baseFormControls.agencyZipCode = this.fb.control(this.data.agencyZipCode || '', Validators.required);
    }

    this.form = this.fb.group(baseFormControls);
  }

  ngOnInit() {
    this.form.get('removePriorWork')?.valueChanges.subscribe((value) => {
      if (value) {
        this.form.get('priorWorksEffectiveDate')?.disable();
        this.form.get('priorWorksEffectiveDate')?.setValue(null);
      } else {
        this.form.get('priorWorksEffectiveDate')?.enable();
      }
    });

    // Ensure cleanup when modal is closed (via any method)
    this.dialogRef.afterClosed().subscribe(() => {
      // Reset form or perform any necessary cleanup
      this.form.reset({ removePriorWork: false, priorWorksEffectiveDate: null, issuedEffectiveDate: null });
    })
  }

  ngAfterViewInit() {
    this.form.get('issuedEffectiveDate')?.setValue(this.data?.effectiveDate);
  }

  onSubmit() {
    this.dialogRef.close(this.form.value);
  }
}
